<template>
  <div class="container">
    <div class style="padding:20px;display: flex;border-bottom: 1px solid rgb(222, 221, 221);">
      <div class="photo" v-if="userInfo.org.logoUrl">
        <img :src="userInfo.org.logoUrl" />
      </div>
      <div class="photo" v-else>
        <img src="http://gd-zymso.oss-cn-beijing.aliyuncs.com/file/png/head/avatar/avatar.png" />
      </div>
      <div class style="text-align: left;margin-left: 10px">
        <h4>{{userInfo.sysUser.realname}}</h4>
        <p style="margin: 15px 0">{{userInfo.org.orgName}}</p>
        <p>{{userInfo.org.provinceName+userInfo.org.cityName+userInfo.org.districtName+(userInfo.org.address?userInfo.org.address:"")}}</p>
      </div>
    </div>
    <ul class="list" style="padding-bottom: 50px">
      <li>
        <router-link to="/Company">
          <span>修改企业信息</span>
          <Icon type="ios-arrow-dropright" class="ic" />
        </router-link>
      </li>
      <li>
        <router-link to="/ProductManage">
          <span>产品管理</span>
          <Icon type="ios-arrow-dropright" class="ic" />
        </router-link>
      </li>
      <li>
        <router-link to="/BrandManage">
          <span>品牌管理</span>
          <Icon type="ios-arrow-dropright" class="ic" />
        </router-link>
      </li>
      <li>
        <router-link to="/Store">
          <span>网店链接</span>
          <Icon type="ios-arrow-dropright" class="ic" />
        </router-link>
      </li>
      <li>
        <router-link to="/AloneCodeJoin">
          <span>码关联</span>
          <Icon type="ios-arrow-dropright" class="ic" />
        </router-link>
      </li>
        <li>
        <router-link to="/Communication">
          <span>添加流通记录</span>
          <Icon type="ios-arrow-dropright" class="ic" />
        </router-link>
      </li>
      <li>
        <router-link to="/Feedback">
          <span>提交反馈</span>
          <Icon type="ios-arrow-dropright" class="ic" />
        </router-link>
      </li>
      <li v-if="loginShow">
        <a
          href="javascript:void(0);"
          @click="bindOpenId()"
          v-if="!this.userInfo.sysUser.wxOpenid||this.userInfo.sysUser.wxOpenid==''"
        >
          <span>绑定微信</span>
          <Icon type="ios-arrow-dropright" class="ic" />
        </a>
      </li>
      <li>
        <router-link to="/Password">
          <span>修改密码</span>
          <Icon type="ios-arrow-dropright" class="ic" />
        </router-link>
      </li>
      <li>
        <a href="javascript:void(0);" @click="logout">
          <span>退出登录</span>
          <Icon type="ios-arrow-dropright" class="ic" />
        </a>
      </li>
    </ul>
    <!-- <div class="tab">
      <cube-tab-bar class="bl" v-model="selectedLabelDefault" :data="tabs" @change="changeHandler">
      </cube-tab-bar>
    </div>-->
  </div>
</template>

<script>
import { getMenus, logout } from "@/api/bapi";
import { removeLs } from "@/api/login";
import { mapGetters } from "vuex";
export default {
  name: "Center",
  data() {
    return {
      selectedLabelDefault: "我的",
      tabs: [
        {
          label: "首页",
          icon: "cubeic-home"
        },
        {
          label: "我的",
          icon: "cubeic-person"
        }
      ],
      userInfo: {},
      loginShow:false,
    };
  },
  computed: {
    httpUrl() {
      return this.$store.state.httpUrl;
    }
  },
   watch: {
    $route(to, from) {
      if (/\/Center/gi.test(to.path)) {
        this.getUserInfo();
      }
    }
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      this.loginShow = false;
      var u = navigator.userAgent;
      let vue = this;
      if (u.indexOf("MicroMessenger") > 0) {
        this.loginShow = true;
      }

      if (localStorage.getItem("loginUserInfo")) {
        this.$axios({
          headers: {
            Authorization:
              localStorage.getItem("token_type") +
              localStorage.getItem("access_token")
          },
          method: "get",
          url: "admin/user/loginInfo"
        })
          .then(res => {
            localStorage.setItem(
              "loginUserInfo",
              JSON.stringify(res.data.data)
            );
            this.userInfo = res.data.data;
          })
          .catch(err => {});
      } else {
        this.$Message.error("登陆失效，请重新登录");
        this.$router.push("/login");
      }
    },
    changeHandler(label) {
      if (label == "我的") {
        this.$router.push({ path: "Center" });
      } else {
        this.$router.push({ path: "Index" });
      }
    },
    bindOpenId() {
      window.location = this.httpUrl + "/portal/webchat/bind";
    },
    logout() {
      // 清除localStorage
      logout().then(res => {
        if (res.status == 200) {
          removeLs();
          this.$router.push({ path: "/login" });
        }
      });
    }
  }
};
</script>

<style scoped>
.tab {
  position: fixed;
  width: 100%;
  bottom: 0;
  border-top: 1px solid #f1ebeb;
  background-color: white;
}
.photo {
  width: 30%;
}
.photo img {
  width: 100%;
}
h4 {
  font-size: 20px;
  font-weight: bold;
  margin-top: 5px;
}
.ic {
  float: right;
}
</style>
<style lang="scss" scoped>
.list {
  width: 100%;
  margin: 0 auto;
  text-align: left;
}
.list li {
  > a {
    display: flex;
    justify-content: space-between;
    padding: 20px;
    background-color: white;
    border-bottom: 1px solid rgb(222, 221, 221);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Center.vue